import React, { useState } from 'react';
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { changePassword } from '../../Redux/Actions/AuthAction';

const ChangePasswordForm = () => {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);

  const [formValues, setFormValues] = useState({
    oldPass: '',
    newPass: '',
    confirmNewPass: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);

  const handleInputChange = ({ target: { name, value } }) =>
    setFormValues(prev => ({ ...prev, [name]: value }));

  const togglePasswordVisibility = () => setShowPassword(prev => !prev);
  const togglePasswordConfirmVisibility = () => setShowConfirmPassword(prev => !prev);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValues.oldPass.trim() || !formValues.newPass.trim() || !formValues.confirmNewPass.trim()) {
      return toast.error('All Fields Are Required !!');
    }

    console.log('Form Submitted:', formValues);
    try {
      await dispatch(changePassword({
        old_password: formValues.oldPass,
        new_password: formValues.newPass,
        confirm_new_password: formValues.confirmNewPass,
      }))

      toast.success('Password Chnaged Successfully..!!');
      setFormValues({
        oldPass: '',
        newPass: '',
        confirmNewPass: '',
      });
    } catch (error) {
      // toast.error(error?.response?.errors?.new_password[0])

      if (error?.response?.data?.errors) {
        const key = error?.response?.data?.errors;
        const firstField = Object.keys(key)[0];
        if (firstField && key[firstField].length > 0) {
          toast.error(key[firstField][0]);
        }
      } else {
        toast.error(error.response.data.message);
      }
    }
  };

  const inputSx = {
    background: "#FFF",
    border: "1px solid #D5D7DA",
    boxShadow: "0px 1px 2px 0px #0A0D120D",
    borderRadius: "0.75rem",
    height: "3rem",
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      boxShadow: '0 0 0 1px #E72848',
    },
  };

  return (
      <div className="w-full gap-5">
        <form className="w-full lg:w-2/3" onSubmit={handleSubmit}>
          <h3 className="py-2 font-bold text-2xl">Change Password</h3>
          <div className="grid grid-cols-3 gap-2 mb-6">
            {/* Old Password Field */}
            <div className="col-span-3 lg:col-span-2 my-1">
              <FormControl fullWidth variant="outlined">
                <OutlinedInput
                  name="oldPass"
                  type={showOldPassword ? 'text' : 'password'}
                  placeholder="Enter Old Password"
                  value={formValues.oldPass}
                  onChange={handleInputChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setShowOldPassword(prev => !prev)}>
                        {showOldPassword ? (
                          <AiOutlineEyeInvisible size={20} style={{ color: '#6B7280' }} />
                        ) : (
                          <AiOutlineEye size={20} style={{ color: '#6B7280' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  sx={inputSx}
                />
              </FormControl>
            </div>
            {/* New Password Field */}
            <div className="col-span-3 lg:col-span-2 my-1">
              <FormControl fullWidth variant="outlined">
                <OutlinedInput
                  name="newPass"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter New Password"
                  value={formValues.newPass}
                  onChange={handleInputChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={togglePasswordVisibility}>
                        {showPassword ? (
                          <AiOutlineEyeInvisible size={20} style={{ color: '#6B7280' }} />
                        ) : (
                          <AiOutlineEye size={20} style={{ color: '#6B7280' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  sx={inputSx}
                />
              </FormControl>
            </div>
            {/* Confirm New Password Field */}
            <div className="col-span-3 lg:col-span-2 my-1">
              <FormControl fullWidth variant="outlined">
                <OutlinedInput
                  name="confirmNewPass"
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Confirm New Password"
                  value={formValues.confirmNewPass}
                  onChange={handleInputChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={togglePasswordConfirmVisibility}>
                        {showConfirmPassword ? (
                          <AiOutlineEyeInvisible size={20} style={{ color: '#6B7280' }} />
                        ) : (
                          <AiOutlineEye size={20} style={{ color: '#6B7280' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  sx={inputSx}
                />
              </FormControl>
            </div>
            {/* Submit Button */}
            <div className="col-span-3 lg:col-span-2 my-2 max-w-max m-auto">
              <button
                type="submit"
                className={`bg-[#E72848] text-[#FFF]  ${Auth.loading ? 'py-1' : 'py-2'}  px-12 rounded-lg font-bold flex justify-center transition-all duration-200 transform hover:scale-[1.02] active:scale-95 shadow-md hover:shadow-lg`}
              >
                {
                  Auth.loading ? (
                    <>
                      <CircularProgress size={24} color="inherit" />
                    </>
                  ) : (
                    "Save"
                  )
                }
              </button>
            </div>
          </div>
        </form>
      </div>
  );
};

export default ChangePasswordForm;
